import { v4 as uuidv4 } from 'uuid';

export const getSessionId = () => {
  const stored = localStorage.getItem('session_id');

  if (stored) {
    const parsed = JSON.parse(stored);
    const now = Date.now();

    if (now - parsed.timestamp < 86400000) {
      return parsed;
    }
  }

  // Create new session
  const newSession = {
    sessionId: localStorage.getItem('session_id'),
    persona: null,
    timestamp: Date.now(),
  };

  localStorage.setItem('session_id', JSON.stringify(newSession));
  return newSession;
};

export const savePersona = (personaData) => {
  const stored = sessionStorage.getItem('tm_session_data');
  if (!stored) return;

  const parsed = JSON.parse(stored);
  parsed.persona = personaData;
  parsed.timestamp = Date.now();

  sessionStorage.setItem('tm_session_data', JSON.stringify(parsed));
};

// 🚀 NEW FUNCTION
export const resetSessionId = () => {
  sessionStorage.removeItem('tm_session_data');

  const newSession = {
    sessionId: uuidv4(),
    persona: null,
    timestamp: Date.now(),
  };

  sessionStorage.setItem('tm_session_data', JSON.stringify(newSession));

  return newSession;
};

export const forceLogout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('session_id');

  window.speechSynthesis?.cancel();

  // Redirect to login
  window.location.href = '/';
};

export const shouldLogout = (err) => {
  if (!err?.response) return true; // network error
  const status = err.response.status;
  return status === 401 || status === 403;
};